module.exports = __webpack_public_path__ + "images/nirvana/nic1.png";